//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/splm.js";
import "../no/CAE.js";
SPLM.CAE.Xyplot = {};
export default SPLM;